import { render } from "./MySidebarButtonBack.vue?vue&type=template&id=dd25d4e0"
import script from "./MySidebarButtonBack.vue?vue&type=script&lang=js"
export * from "./MySidebarButtonBack.vue?vue&type=script&lang=js"

import exportComponent from "/home/fluffypony/Projects/cards/cards-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__